import React from 'react';
import Loading from 'src/components/Loading/Loading';
import { observer } from 'src/utils/mobx-react';
import api from 'src/api';
import { useAppStateContext } from 'src/AppState/AppState';
import { finish as finishLogin } from 'src/modules/user/actions/login';

const UniverseSwitcherPage = observer('UniverseSwitcherPage', () => {
    const appState = useAppStateContext();

    React.useEffect(() => {
        const token = appState.routerBackoffice.getParametersString('global', 'token');
        const universe = appState.routerBackoffice.getParametersString('global', 'universe') ?? 'star';

        if (token === null) {
            appState.routerBackoffice.redirectToGlobal();
            return;
        }

        api.post(`/session/universe-switch`, {
            universe,
            token,
        }).then(
            (data: unknown) => {
                appState.reduxAction.dispatchAction(finishLogin(data));
                appState.routerBackoffice.redirectToGlobal();
            },
            () => {
                appState.routerBackoffice.redirectToGlobal();
            }
        );
    }, []);

    return (
        <div className='universe-page'>
            <Loading
                active={true}
                message='Switching universe, please wait...'
            />
        </div>
    );
});

// eslint-disable-next-line import/no-default-export
export default UniverseSwitcherPage;
